<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div
          class="is-flex is-justify-content-space-between w-full is-align-items-center"
        >
          <div class="is-size-4 has-text-weight-bold">Historial</div>
          <Button
            variant="main"
            :spinner="downloading"
            :disabled="downloading"
            @click.native="downloadCSV"
          >
            Descargar CSV
          </Button>
        </div>
      </template>
      <template slot="content">
        <div class="filterContainer">
          <div class="column px-0">
            <b-field label="Buscar:">
              <b-input
                v-model="query.search"
                placeholder="Nombre, documento..."
                icon="search"
                @input="filterOrderList"
              />
            </b-field>
          </div>
          <div class="column px-0">
            <b-field label="Local:">
              <b-select
                placeholder="Seleccione una opción"
                v-model="query.local"
                icon="home"
                size="is-regular"
                @input="filterOrderList"
              >
                <option
                  v-for="local in locals"
                  :key="local.id"
                  :value="local.id"
                  >{{ local.name }}</option
                >
              </b-select>
            </b-field>
          </div>
          <div class="specialContainer">
            <div class="column px-0">
              <b-field label="Fecha Desde">
                <b-datepicker
                  placeholder="Elige una fecha"
                  v-model="dateFilter.date_from"
                  @input="formatDate('date_from')"
                  icon="calendar"
                >
                  <button
                    class="button is-danger"
                    @click="clearDate('date_from')"
                  >
                    <span>Limpiar</span>
                  </button>
                </b-datepicker>
              </b-field>
            </div>
            <div class="column px-0">
              <b-field label="Fecha Hasta">
                <b-datepicker
                  placeholder="Elige una fecha"
                  v-model="dateFilter.date_to"
                  @input="formatDate('date_to')"
                  icon="calendar"
                  :mobile-native="false"
                >
                  <button
                    class="button is-danger"
                    @click="clearDate('date_to')"
                  >
                    <span>Limpiar</span>
                  </button>
                </b-datepicker>
              </b-field>
            </div>
            <div class="column px-0">
              <b-field label="Tipo:">
                <b-select
                  placeholder="Seleccione una opción"
                  v-model="query.is_recompensa"
                  icon="tag"
                  size="is-regular"
                  @input="filterOrderList"
                >
                  <option :value="null">Todos</option>
                  <option :value="true">Canje</option>
                  <option :value="false">Visita</option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
        <b-table
          :loading="isLoading"
          :data="results"
          hoverable
          striped
          detail-key="id"
          icon-pack="fas"
        >
          <b-table-column label="Fecha" field="creation" v-slot="props">
            {{ props.row.creation }}
          </b-table-column>
          <b-table-column
            label="Producto"
            field="product"
            sortable
            v-slot="props"
          >
            {{
              props.row.product_variant ? props.row.product_variant.name : "-"
            }}
          </b-table-column>
          <b-table-column label="Local" field="local" v-slot="props">
            {{ props.row.local.name }}
          </b-table-column>
          <b-table-column label="Cliente" field="client" v-slot="props">
            {{ props.row.client_company.first_name }}
            {{ props.row.client_company.last_name }}
          </b-table-column>
          <b-table-column label="Documento" field="num_document" v-slot="props">
            {{ props.row.client_company.num_document }}
          </b-table-column>
          <b-table-column label="Teléfono" field="phone" v-slot="props">
            {{ props.row.phone || "-" }}
          </b-table-column>
          <b-table-column label="Correo" field="email" v-slot="props">
            {{ props.row.email || "-" }}
          </b-table-column>
          <b-table-column label="Tipo" field="is_recompensa" v-slot="props">
            <b-tag :type="props.row.is_recompensa ? 'is-success' : 'is-info'">
              {{ props.row.is_recompensa ? "Canje" : "Visita" }}
            </b-tag>
          </b-table-column>

          <LoadingTable slot="empty" :isLoading="isLoading" />
        </b-table>
      </template>
    </Card>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import LocalService from "@/services/validador/LocalService";
import OrderService from "@/services/validador/OrderService";
import LoadingTable from "@/components/base/LoadingTable";
import Button from "@/components/form/Button";
import formatDate from "@/mixins/formatDate";
import { STATUS_ORDER } from "../../../utils/constants";
export default {
  name: "OrderList",
  components: {
    Layout,
    Card,
    LoadingTable,
    Button
  },
  mixins: [formatDate],
  data() {
    return {
      locals: [],
      results: [],
      products: [],
      downloading: false,
      dateFilter: {
        date_from: null,
        date_to: null
      },
      isLoading: true,
      query: {
        local: null,
        date_from: null,
        date_to: null,
        product: null,
        status: null,
        is_recompensa: null,
        search: null
      }
    };
  },
  computed: {
    statusOrderList() {
      return Object.entries(STATUS_ORDER);
    }
  },
  created() {
    this.getLocals();
  },
  methods: {
    getNameStatusOrder(status) {
      return STATUS_ORDER[status];
    },
    getClassStatusOrder(status) {
      switch (status) {
        case "B":
          return "is-warning";
        case "O":
          return "is-primary";
        case "P":
          return "is-twitter";
        default:
          return "is-warning";
      }
    },
    showMessage(type = "D", msg = "Ocurrió un error") {
      this.$store.commit("settings/SET_ALERT", {
        isAlert: true,
        type,
        msg
      });
    },
    async getLocals() {
      this.isLoading = true;
      try {
        const response = await LocalService.getLocalList();
        this.locals = response.data;
        this.query.local = this.locals[0].id;
        await this.getOrderList();
      } catch (error) {
        this.showMessage("D", "No se pudo obtener la lista de locales");
      } finally {
        this.isLoading = false;
      }
    },
    filterOrderList() {
      this.getOrderList();
    },
    async downloadCSV() {
      this.downloading = true;
      try {
        const response = await OrderService.downloadOrderRecompensaCSV(
          this.query
        );
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "text/csv;charset=utf-8" })
        );
        const link = document.createElement("a");
        const disposition = response.headers["content-disposition"] || "";
        const fileNameMatch = disposition.match(/filename="?([^";]+)"?/);
        link.href = url;
        link.download = fileNameMatch
          ? fileNameMatch[1]
          : "historial_recompensas.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.showMessage("D", "No se pudo descargar el historial");
      } finally {
        this.downloading = false;
      }
    },
    async getOrderList() {
      this.isLoading = true;
      try {
        const response = await OrderService.getOrderRecompensaList(this.query);
        this.results = response.data;
      } catch (error) {
        this.showMessage();
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(value) {
      this.query[value] = this.formatDateReverse(this.dateFilter[value]);
      this.filterOrderList();
    },
    clearDate(value) {
      this.dateFilter[value] = null;
      this.query[value] = null;
      this.filterOrderList();
    }
  }
};
</script>

<style lang="scss">
.b-table .table th.is-sortable {
  border-color: rgba(34, 43, 59, 0.05);
}
.custom-card {
  border: 1px solid #dbdbdb;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}
.specialContainer {
  grid-column-start: 1;
  grid-column-end: 3;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1rem;
  @media (max-width: 860px) {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-template-columns: 1fr;
  }
}
</style>
